import { NgModule } from '@angular/core';
import { BnAccountDetailService } from './bn-account-detail/bn-account-detail.service';
import { BnContactCreateService } from './bn-contact-create/bn-contact-create.service';
import { TransfersService } from './transfers/transfers.service';
import { DomAttributesService } from './dom-attributes/dom-attributes.service';
import { ModalService } from './transfers/modal-service.service';


@NgModule({
  providers: [
    TransfersService,
    DomAttributesService,
    BnContactCreateService,
    BnAccountDetailService,
    ModalService
  ]
})
export class UiLibraryServicesModule { }
